export const dateStringToDate = ({ value }: { value: string }) => new Date(value);

export const dateStringToDateOptional = ({ value }: { value?: string }) => value
	? dateStringToDate({ value })
	: value;
